import { TypeOrder } from '../../interfaces/Order/TypeOrder'
import {
  GET_TYPE_ORDER,
  GET_TYPE_ORDER_EXITO
} from '../types/typeOrderActionsTypes'

export type TypeOrderAction = TypesOrderAction | TypesOrderActionAsync

// Esto va a REDUX
export interface TypesOrderAction {
  type: typeof GET_TYPE_ORDER_EXITO
  typesOrder: TypeOrder[] | undefined
  error: string | undefined
}

export const getTypesOrderAction = (
  typesOrder?: TypeOrder[],
  error?: string
): TypesOrderAction => {
  return {
    type: GET_TYPE_ORDER_EXITO,
    typesOrder,
    error
  }
}

// Esto va a SAGA
export interface TypesOrderActionAsync {
  type: typeof GET_TYPE_ORDER
}

export const getTypesOrderActionAsync = (): TypesOrderActionAsync => {
  return {
    type: GET_TYPE_ORDER
  }
}
